import { render, staticRenderFns } from "./SelectedMemberItem.vue?vue&type=template&id=127c0a75&"
import script from "./SelectedMemberItem.vue?vue&type=script&lang=js&"
export * from "./SelectedMemberItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectedMemberItem.vue?vue&type=style&index=0&id=127c0a75&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports